





















































import Vue from 'vue';
import { mapActions } from 'vuex';

export default Vue.extend({
  name: 'Login',

  data: () => ({
    isLogin: true,

    username: '',

    password: '',

    passwordCheck: '',

    name: '',
  }),

  methods: {
    ...mapActions('user', [
      'login',
      'register',
    ]),

    execute() {
      if (this.isLogin) {
        this.login({
          username: this.username,
          password: this.password,
        });
      } else {
        this.register({
          name: this.name,
          username: this.username,
          password: this.password,
        });
      }
    },

    toggleLoginRegister() {
      this.isLogin = !this.isLogin;
    },
  },

  computed: {
    title() {
      if (this.isLogin) {
        return 'Login to you account';
      }
      return 'Join by making an account.';
    },

    toggleButtonText() {
      if (this.isLogin) {
        return 'Register Instead';
      }
      return 'Login Instead';
    },

    submitButtonText() {
      if (this.isLogin) {
        return 'Login';
      }
      return 'Register';
    },

    valid() {
      return (this.username.length > 0
        && this.password.length > 0
        && (
          this.isLogin
          || (this.passwordCheck.length > 0 && this.password === this.passwordCheck && this.name.length > 0))
      );
    },
  },
});
